import React from 'react';
import { PhoneCall, Headset } from 'lucide-react';
import { FEATURES } from '../../config/features';

/**
 * A/B arm "banner" — sits directly above the result mode tabs.
 * Compact on mobile (one row, subtitle hidden), roomier from sm up.
 * Outside "Call us" hours the button says "Request a callback" instead of the call CTA.
 */
const CallBanner = ({ text, onClick, callUsOpen = true }) => {
    if (!FEATURES.ENABLE_CONTACT_FORM || !text) return null;

    const cta = callUsOpen ? text.cta : 'Get a callback';
    const subtitle = callUsOpen
        ? 'Our travel experts can help you find confirmed seats.'
        : "Leave your number and our travel experts will call you back.";

    return (
        <div
            role="complementary"
            aria-label="Travel assistance"
            className="flex items-center gap-3 sm:gap-4 rounded-2xl border border-orange-200 bg-white/95
                       px-3 py-2.5 sm:px-5 sm:py-3.5 shadow-[0_6px_20px_-10px_rgba(234,88,12,0.35)]"
        >
            <div
                className="hidden min-[400px]:flex shrink-0 w-9 h-9 sm:w-11 sm:h-11 rounded-xl bg-orange-50 text-orange-600
                           items-center justify-center"
                aria-hidden="true"
            >
                <Headset className="w-[18px] h-[18px] sm:w-[22px] sm:h-[22px]" />
            </div>

            <div className="min-w-0 flex-1">
                <p className="text-[13px] sm:text-base font-semibold text-slate-900 leading-snug">
                    {text.headline}
                </p>
                <p className="hidden sm:block text-sm text-slate-500 leading-snug mt-0.5">
                    {subtitle}
                </p>
            </div>

            <button
                type="button"
                onClick={onClick}
                className="shrink-0 inline-flex items-center justify-center gap-1.5 min-h-[40px] sm:min-h-[44px]
                           px-3 sm:px-5 rounded-xl bg-orange-500 hover:bg-orange-600 active:bg-orange-700
                           text-white text-[13px] sm:text-sm font-semibold whitespace-nowrap
                           shadow-sm shadow-orange-500/30 transition-colors
                           focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-500 focus-visible:ring-offset-2"
            >
                <PhoneCall size={15} aria-hidden="true" />
                {cta}
            </button>
        </div>
    );
};

export default CallBanner;
